import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { RootState } from '../../reducers';
import theme from '../../theme/default';
import { unscheduleDeleteAccount } from './authThunks';
import { removeToken } from '../../lib/localStorageHandler';
import { getInitialState } from '../app/appSlice';
import { setAlertMessage } from '../dashboard/dashboardSlice';

const AccountDeletingCover = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const deleteRequestedAt = useSelector(
    (state: RootState) => state.settings.user.deleteRequestedAt
  );

  const deleteRequestedMoment = moment(deleteRequestedAt);
  const deletionDate = moment(deleteRequestedMoment).add(14, 'days');
  const currentDate = moment();
  const daysRemaining = deletionDate.diff(currentDate, 'days');

  const handleProceed = async () => {
    await dispatch(unscheduleDeleteAccount());
    await dispatch(getInitialState());
    dispatch(
      setAlertMessage({
        type: 'success',
        message: t('auth.accountDeletion.restored'),
      })
    );
  };

  const handleCancel = () => {
    removeToken();
    // Force reload, and go to home page
    window.location.href = '/';
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '98vh',
        backgroundColor: theme.palette.background.default,
      }}
    >
      <Box
        sx={{
          p: theme.spacing(4),
          borderRadius: theme.spacing(2),
          backgroundColor: theme.palette.background.paper,
          border: `1px solid ${theme.palette.secondary.main}`,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          maxWidth: 400,
          textAlign: 'left',
        }}
      >
        <Typography variant="h4" sx={{ mb: 2 }}>
          {t('auth.accountDeletion.title')}
        </Typography>
        <Box sx={{ width: 320, textAlign: 'left', mb: 3 }}>
          <Typography variant="body1" sx={{ marginBottom: 3 }}>
            {t('auth.accountDeletion.daysRemaining', { days: daysRemaining })}
          </Typography>
          <Typography variant="body2" sx={{ marginBottom: 3 }}>
            {t('auth.accountDeletion.dataRemoval', { days: daysRemaining })}
          </Typography>
          <Typography variant="body2" sx={{ marginBottom: 3 }}>
            {t('auth.accountDeletion.cancellation')}
          </Typography>
        </Box>
        <Box sx={{ mb: 2, width: 320 }}>
          <Button
            id="proceed-to-signin-button"
            variant="contained"
            color="primary"
            fullWidth
            sx={{ padding: theme.spacing(2) }}
            onClick={handleProceed}
          >
            {t('auth.accountDeletion.proceed')}
          </Button>
        </Box>
        <Box sx={{ mb: 2, width: 320 }}>
          <Button
            id="cancel-button"
            variant="text"
            fullWidth
            sx={{ padding: theme.spacing(2) }}
            onClick={handleCancel}
          >
            {t('auth.accountDeletion.cancel')}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default AccountDeletingCover;
